export function initLoadAllSpecs() {
  document.querySelectorAll('.specs-section.is-collapsed').forEach(section => {
    const grid = section.querySelector('.specs-section__grid');
    const toggle = section.querySelector('.specs-section__toggle');
    if (!grid || !toggle) return;

    // Measure height of first 8 items + their gaps (gap-y-6 = 24px)
    const items = Array.from(grid.children);
    let collapsedHeight = items
      .slice(0, 8)
      .reduce((sum, el) => sum + el.offsetHeight, 0) + (7 * 24);

    grid.style.maxHeight = collapsedHeight + 'px';

    toggle.addEventListener('click', () => {
      const isExpanded = toggle.getAttribute('aria-expanded') === 'true';

      if (isExpanded) {
        grid.style.maxHeight = collapsedHeight + 'px';
        section.classList.add('is-collapsed');
        toggle.textContent = 'Vis alle specifikationer';
      } else {
        grid.style.maxHeight = grid.scrollHeight + 'px';
        section.classList.remove('is-collapsed');
        toggle.textContent = 'Vis færre';
      }

      toggle.setAttribute('aria-expanded', String(!isExpanded));
    });
  });
}